import React from "react";
import { IframeComponent } from "../../components/IframeComponent";

const SpaceCombat = () => {
  return <IframeComponent Srclink="https://inspiring-palmier-1e74ca.netlify.app/" />;
};

export default SpaceCombat;
